import { useTranslation } from 'react-i18next'
import type { Instance } from '../api/client'

const statusStyle: Record<Instance['status'], { dot: string; text: string }> = {
  pending_approval: { dot: 'bg-purple-400 animate-pulse', text: 'text-purple-700' },
  provisioning: { dot: 'bg-yellow-400 animate-pulse', text: 'text-yellow-700' },
  initializing: { dot: 'bg-blue-400 animate-pulse',  text: 'text-blue-700'  },
  updating:     { dot: 'bg-amber-400 animate-pulse', text: 'text-amber-700' },
  restarting:   { dot: 'bg-sky-400 animate-pulse',   text: 'text-sky-700'   },
  running:      { dot: 'bg-green-400',                text: 'text-green-700' },
  stopped:      { dot: 'bg-gray-400',                 text: 'text-gray-600'  },
  error:        { dot: 'bg-red-500',                  text: 'text-red-700'   },
  deleting:     { dot: 'bg-orange-400 animate-pulse', text: 'text-orange-700'},
  restoring:            { dot: 'bg-amber-400 animate-pulse',  text: 'text-amber-700' },
  replacing_filestore:  { dot: 'bg-amber-400 animate-pulse',  text: 'text-amber-700' },
}

export default function StatusBadge({ status }: { status: Instance['status'] }) {
  const { t } = useTranslation()
  const style = statusStyle[status] ?? statusStyle.stopped
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${style.text}`}>
      <span className={`w-2 h-2 rounded-full ${style.dot}`} />
      {t(`status.${status}`)}
    </span>
  )
}
